import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import TopBarReducer from './TopBar.reducer';
import DashboardReducer from './dashboard.reducer';
import OrdersReducer from './orders.reducer';
import AuthReducer from './auth.reducer';
import RestaurantsReducer from './restaurants.reducer';
import AppReducer from './app.reducer';

export default combineReducers({
  topBar: TopBarReducer,
  dashboard: DashboardReducer,
  orders: OrdersReducer,
  auth: AuthReducer,
  restaurants: RestaurantsReducer,
  app: AppReducer,
  form,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js